// import React from 'react';
// import { Helmet } from "react-helmet";
// import { Row, Col, Card } from "react-bootstrap";
// import BankRoll from "../../Components/Game/BankRoll";
// import Queue from "../../Components/Game/Queue";
// import TopBarGames from "../../Components/Game/Addons/TopBar";
// import Engine from "./Engine";
// import Game from "./Game";
// import Bet from "./Bet";
// import { isMobile, wait, Event } from "../../../Helper";
// import Loading from "../Loading";
// import PlinkoPopup from './Graph';

// class Index extends React.Component {
//     _Mounted = false;
//     constructor(props) {
//         super(props);
//         this.state = {
//             engine: new Engine(),
//             canvas: null,
//             padding: "p-1",
//             showPopup: false
//         };
//         this.handleShowPopUp = this.handleShowPopUp.bind(this);
//         this.handleResize = this.handleResize.bind(this);
//     }

//     handleShowPopUp() {
//         this.setState((prevState) => ({
//             showPopup: !prevState.showPopup
//         }));
//     }
//     componentDidMount() {
//         let { engine } = this.state;

//         document.body.scrollTop = 0;
//         document.documentElement.scrollTop = 0;

//         // Start Engine
//         engine.started = true;

//         wait(600).then(() => {
//             this.handleResize();
//         });
//         window.addEventListener('resize', this.handleResize);
//     }

//     componentWillMount() {
//         this._Mounted = true;

//         this.setState({ canvas: <Game engine={this.state.engine} /> });

//         wait(800).then(() => {
//             this.setState({ visibility: 'visible' })
//         })
//     }

//     componentWillUnmount() {
//         let { engine } = this.state;
//         window.removeEventListener('resize', this.handleResize);
//         this._Mounted = false;

//         // Stop Engine
//         engine.started = false;
//         engine.trigger = null;
//         engine.off()
//     }

//     handleResize() {
//         let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

//         if (clientWidth < 1540) {
//             this.setState({ col: 'col-xl-12' });
//             Event.emit('hide_games');
//         }
//         else {
//             this.setState({ col: 'col-xl-9' });
//             Event.emit('show_min_games');
//         }

//         if (isMobile()) {
//             this.setState({ padding: 'p-0', ovh: 'ovh' });
//         }
//     }

//     render() {
//         let { col, padding, ovh, visibility } = this.state;
//         const help = <p className="text-white">In order to play the game Plinko you will choose a bet amount and the place your bet. Each pocket has a multiplier attached that will multiply your bet amount. When the ball lands in that pocket you will win that bet. <br /> Example: If you bet .10 and the ball lands in the pocked x1.00 you will win .10 or 1x your bet amount. If the ball lands in the pocket X0.50 you will win .05 or half of your bet amount. </p>;
//         return (
//             <>
//                 <Helmet>
//                     <title>Plinko</title>
//                     <meta name="keywords" content="Crypto Plinko Game, Online Plinko Game, Bitcoin Plinko Game, Blockchain Plinko Game, Best Crypto Plinko Game, PlayCrash.com Plinko" />
//                     <meta name="description" content="In order to play the crypto Plinko game you will choose a bet amount and the place your bet. Each pocket has a multiplier attached that will multiply your bet amount. When the ball lands in that pocket you will win that bet." />
//                     <meta name="og:title" content="Play Online Plinko - Play with USDT, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <meta name="og:description" content="Play Online Plinko - Play with USDT, ETH LTC, USDT, BCH, TRX and many more !" />
//                     <link rel="canonical" href="/plinko" />
//                 </Helmet>
//                 <div >
//                     {this._Mounted ?

//                         <div className={`${col} ${padding}`} style={{ position: 'relative', width: '100%', height: '100%' }}>
//                             {this.state.showPopup && (
//                                 <PlinkoPopup
//                                     onClose={this.handleShowPopUp}
//                                     engine={this.state.engine}
//                                 />
//                             )}
//                             <Row className={"animated fadeIn " + ovh} style={{ visibility: visibility }}>
//                                 <div className="d-none">{help}</div>
//                                 <Col sm={12} className={'m-auto ' + col + ' ' + padding}>

//                                     {/* BANKROLL */}
//                                     <Card className="mb-0">
//                                         <Card.Body className="px-2 py-3">
//                                             <Row>
//                                                 <Col md={6} className={'col-6 text-left'}>
//                                                     <BankRoll game={'plinko'} />
//                                                 </Col>
//                                                 <div style={{ display: 'flex' }}>

//                                                     <Col md={6} className={'col-6 text-right'}>
//                                                         <TopBarGames help={help} image="/assets/images/covers_new/____hilo.png" />
//                                                     </Col>
//                                                     <div onClick={this.handleShowPopUp} style={{ marginLeft: '26px', alignItems: 'center', height: '37px', width: '37px', borderRadius: '5px', backgroundColor: "#1B2336", display: 'flex', justifyContent: 'center' }}>
//                                                         <img style={{ height: '17px', width: '17px' }} src="/assets/images/nanoicons/nanoswap.png" alt="Swap" />

//                                                     </div>
//                                                 </div>
//                                             </Row>
//                                         </Card.Body>
//                                     </Card>

//                                     {/* GAME */}
//                                     <Card className="mb-0">
//                                         <Card.Body className={'p-0'} id="roll-panel2">
//                                             <Row>
//                                                 <Col sm={12} md={12} className={'m-auto'}>
//                                                     <ul className={'plinko-crash'} id={'pc'} />
//                                                     {this._Mounted &&
//                                                         <>{this.state.canvas}</>
//                                                     }
//                                                 </Col>
//                                             </Row>
//                                         </Card.Body>
//                                     </Card>

//                                     {/* BET */}
//                                     <Card className="mb-0">
//                                         <Card.Body className={padding}>
//                                             <Row>
//                                                 <Col sm={12} md={10} className={'m-auto'}>
//                                                     <Bet engine={this.state.engine} t={this.props.t} />
//                                                 </Col>
//                                             </Row>
//                                         </Card.Body>
//                                     </Card>

//                                     {/* QUEUE */}
//                                     <Card className="mb-5">
//                                         <Card.Body className="p-1">
//                                             <Row>
//                                                 <Col sm={12} md={12} className={'m-auto px-1'}>
//                                                     <Queue t={this.props.t} game={'plinko'} />
//                                                 </Col>
//                                             </Row>
//                                         </Card.Body>
//                                     </Card>

//                                 </Col>
//                             </Row>
//                         </div>
//                         :
//                         <Loading />
//                     }
//                 </div>
//             </>
//         );
//     }
// }

// export default Index;


// vivek


import React from 'react';
import { Helmet } from "react-helmet";
import { Row, Col, Card } from "react-bootstrap";
import BankRoll from "../../Components/Game/BankRoll";
import Queue from "../../Components/Game/Queue";
import TopBarGames from "../../Components/Game/Addons/TopBar";
import Engine from "./Engine";
import Game from "./Game";
import Bet from "./Bet";
import { isMobile, wait, Event } from "../../../Helper";
import Loading from "../Loading";
import PlinkoPopup from './Graph';

class Index extends React.Component {
    _Mounted = false;
    constructor(props) {
        super(props);
        this.state = {
            engine: new Engine(),
            canvas: null,
            padding: "p-1",
            showPopup: false
        };
        this.handleShowPopUp = this.handleShowPopUp.bind(this);
        this.handleResize = this.handleResize.bind(this);
    }

    handleShowPopUp() {
        this.setState((prevState) => ({
            showPopup: !prevState.showPopup
        }));
    }
    componentDidMount() {
        let { engine } = this.state;

        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        // Start Engine
        engine.started = true;

        wait(600).then(() => {
            this.handleResize();
        });
        window.addEventListener('resize', this.handleResize);
    }

    componentWillMount() {
        this._Mounted = true;

        this.setState({ canvas: <Game engine={this.state.engine} /> });

        wait(800).then(() => {
            this.setState({ visibility: 'visible' })
        })
    }

    componentWillUnmount() {
        let { engine } = this.state;
        window.removeEventListener('resize', this.handleResize);
        this._Mounted = false;

        // Stop Engine
        engine.started = false;
        engine.trigger = null;
        engine.off()
    }

    handleResize() {
        let clientWidth = document.documentElement.clientWidth || document.body.clientWidth;

        if (clientWidth < 1540) {
            this.setState({ col: 'col-xl-12' });
            Event.emit('hide_games');
        }
        else {
            this.setState({ col: 'col-xl-9' });
            Event.emit('show_min_games');
        }

        if (isMobile()) {
            this.setState({ padding: 'p-0', ovh: 'ovh' });
        }
    }

    render() {
        let { col, padding, ovh, visibility } = this.state;
        const help = <p className="text-white">In order to play the game Plinko you will choose a bet amount and the place your bet. Each pocket has a multiplier attached that will multiply your bet amount. When the ball lands in that pocket you will win that bet. <br /> Example: If you bet .10 and the ball lands in the pocked x1.00 you will win .10 or 1x your bet amount. If the ball lands in the pocket X0.50 you will win .05 or half of your bet amount. </p>;
        return (
            <>
                <Helmet>
                    <title>Plinko</title>
                   
                    <link rel="canonical" href="/plinko" />
                </Helmet>
                <div >
                    {this._Mounted ?

                        <div className={`${col} ${padding}`} style={{ position: 'relative', width: '100%', height: '100%' }}>
                            {this.state.showPopup && (
                                <PlinkoPopup
                                    onClose={this.handleShowPopUp}
                                    engine={this.state.engine}
                                />
                            )}
                            <Row className={"animated fadeIn " + ovh} style={{ visibility: visibility }}>
                                <div className="d-none">{help}</div>
                                <Col sm={12} className={'m-auto ' + col + ' ' + padding}>

{/* vivek */}
                    {/* pilingo container */}
                          <div className='mine-containers'>

{/* pilingo game */}

<div className='game-containers'>
                            <div 
                                className='game-header'
                                style={{
                                    // width: "100%", 
                                    // height: "100%",  // Use 100vh for full viewport height
                                    padding: "0px 10px", 
                                    backgroundColor: "#17181b", 
                                    display: "flex", 
                                    justifyContent: "center",  // Center the container horizontally
                                    alignItems: "center",      // Center the container vertically
                                    boxSizing: "border-box",   // Ensure padding doesn't affect the width/height
                                    // opacity:0.9,
                                    // borderTopLeftRadius: "1rem",  // Top-left corner rounded
                                    borderTopRightRadius: "1rem", // Top-right corner rounded
                                    
                                }}
                            >

                                <div style={{
                                    width: "100%",
                                    height: "auto", 
                                    display: "flex",
                                    justifyContent: "space-around", 
                                    alignItems: "center", 
                                    gap: "10px",
                                    // border:"2px solid red",   // Allow wrapping on smaller screens
                                }}>
                                    {/* First Circle */}
                                    <div 
                                     className='header-content'
                                style={{
                                    borderRadius: "2rem",  // Ensure it is circular
                                    width: "100%",         // Adjust width as a percentage for responsiveness
                                    height: "auto",      // Fixed height for the div
                                    display: "flex", 
                                    flexDirection: "column", 
                                    justifyContent: "center", // Vertically centers content
                                    alignItems: "center", // Horizontally centers content
                                    textAlign: "center", 
                                    color: "white", 
                                    boxSizing: "border-box",
                                    flex: "2",
                                    padding:"13px",
                                    whiteSpace: "nowrap",       // Prevent text from wrapping
                                    textOverflow: "ellipsis", 
                                }}
                            >
                               
                                    </div>

                                    {/* Second Circle */}
                                    <div 
                                        style={{
                                            // border: "2px solid yellow", 
                                            borderRadius: "2rem",  // Ensure it is circular
                                            width: "100%",         // Adjust width as a percentage for responsiveness
                                            height: "100%",      // Fixed height, same as above for uniformity
                                            display: "flex", 
                                            justifyContent: "center", 
                                            alignItems: "center", 
                                            textAlign: "center", 
                                            color: "white", 
                                            fontSize: "15px",
                                            fontWeight:"bold",
                                            padding: "13px",
                                            boxSizing: "border-box",
                                            flex:"3",
                                            backgroundColor: "#26272c",
                                            color:"gray",
                                            overflow: "hidden",         // Hide overflowed content
                                            whiteSpace: "nowrap",       // Prevent text from wrapping
                                            textOverflow: "ellipsis",  
                                        }}
                                        className='fontChange header-content second-header-content'
                                    >
                            
                                Game results will be displayed here.
                                
                                    </div>
                                </div>
                            </div>



                                 
                                    {/* GAME */}
                                    <Card className="mb-0" style={{backgroundColor:"#17181b" }}>
                                        <Card.Body className={'p-0'} id="roll-panel2">
                                            <Row>
                                                <Col sm={12} md={12} className={'m-auto'}>
                                                    <ul className={'plinko-crash'} id={'pc'} />
                                                    {this._Mounted &&
                                                        <>{this.state.canvas}</>
                                                    }
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
</div>
{/* pilingo bet */}
<div className='bet-containers'>
                                    {/* BET */}
                                    <Card className="mb-0 bet-body" style={{backgroundColor:"#17181b", padding:"5px",borderRight:"1px solid #222328" ,height:"100%"}}>
                                        <Card.Body className={padding}>
                                            <Row>
                                                <Col sm={12} md={12} className={'m-auto'}>
                                                    <Bet engine={this.state.engine} t={this.props.t} />
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                           </div>
                          </div>

                                    


                                       {/* BANKROLL */}
                                       <Card className="mb-0"
                                       style={{backgroundColor:"#17181b",
                                        borderBottomLeftRadius:"1rem",
                                        borderBottomRightRadius:"1rem",
                                        borderTop:"1px solid #222328"
                                        
                                         }}
                                       >
                                        <Card.Body className="px-2 py-3">
                                            <Row>
                                                <Col md={6} className={'col-6 text-left'} >
                                                    <BankRoll game={'plinko'} />
                                                </Col>
                                                <div style={{display: 'flex',width:"40%" }}>

                                                    <Col md={12} className={'col-12 text-right'}  style={{display:"flex",gap:"8px",justifyContent:"flex-end",textAlign:"center",justifyItems:"center",alignItems:"center"}}>
                                                        <TopBarGames help={help} image="/assets/images/covers_new/____hilo.png" />
                                                        <div onClick={this.handleShowPopUp}
                                                     style={{
                                                        //  marginLeft: '26px',
                                                      alignItems: 'center',
                                                       height: '37px',
                                                        width: '37px',
                                                        //  borderRadius: '5px',
                                                        //   backgroundColor: "#1B2336",
                                                           display: 'flex',
                                                            justifyContent: 'center'
                                                             }}>
                                                        <img style={{ height: '21px', width: '21px' }} src="/assets/images/nanoicons/nanoswap.png" alt="Swap" />

                                                    </div>
                                                    </Col>
                                                   
                                                </div>
                                            </Row>
                                        </Card.Body>
                                    </Card>


                                    {/* QUEUE */}
                                    <Card className="mb-5 mt-3" style={{
                                        borderRadius:"2rem",
                                        backgroundColor:"#17181b"
                                    }}>
                                        <Card.Body className="p-1">
                                            <Row>
                                                <Col sm={12} md={12} className={'m-auto px-1'}>
                                                    <Queue t={this.props.t} game={'plinko'} />
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>

                                </Col>
                            </Row>
                        </div>
                        :
                        <Loading />
                    }
                </div>
            </>
        );
    }
}

export default Index;
